export default __webpack_public_path__ + "static/media/April2018.e65fd3b7.png";